import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SampleKey } from '@tallyframe/core';
import { api } from './client';
import { queryKeys } from './queries';

/** Derived server-side from live data, so it is refetched on every mount even inside the default staleTime. */
export function useOnboarding(workspaceId: string) {
  return useQuery({
    queryKey: queryKeys.onboarding(workspaceId),
    queryFn: ({ signal }) => api.getOnboarding(signal),
    refetchOnMount: 'always'
  });
}

export const meQueryOptions = () =>
  ({ queryKey: queryKeys.me(), queryFn: () => api.me().then((r) => r.principal) }) as const;

/** The caller's principal; its id keys the per-user dismissal flags. */
export function useMe() {
  return useQuery(meQueryOptions());
}

export function useAddSample(workspaceId: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (key: SampleKey) => api.addSample(key),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: queryKeys.reports(workspaceId) });
      await client.invalidateQueries({ queryKey: queryKeys.onboarding(workspaceId) });
    }
  });
}
